export default __webpack_public_path__ + "static/media/bishop1.a14aed81.png";